import { deleteRequest, get, publicPost, put } from "../helpers/apihelpers";

export const CreateCaseTypeService=async(data)=>{
    try {
        const result = await publicPost(`api/case_type/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCaseTypeService=async(data,id)=>{
    try {
        const result = await put(`api/case_type/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCaseTypeService=async(page=1)=>{
    try {
        const result = await get(`api/case_type/get?page=${page}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const FilterCaseTypeService=async(search='',page=1)=>{
    try {
        const result = await get(`api/case_type/filter?search=${search}&page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteCaseTypeService=async(id)=>{
    try {
        const result = await deleteRequest(`api/case_type/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}